(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/newstt/assets/javascripts/views/news-tt-list.js') >= 0) return;  svs.modules.push('/components/statistics/newstt/assets/javascripts/views/news-tt-list.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.newstt = svs.statistics.newstt || {};
  svs.statistics.newstt.views = svs.statistics.newstt.views || {};

  svs.statistics.newstt.views.NewsTTList = svs.sport.news.views.NewsList.extend(
    {
      childView: svs.statistics.newstt.views.NewsTTArticle,

      className: 'statistics-elements grid-row',
      initialize: function(options) {
        if (
          !_.has(options.params, 'parentId') ||
          !_.has(options.params, 'domainCategories')
        ) {
          svs.sport.news.log.warn(
            'Any of the following was not defined options.parentId or options.domainCategories.',
            this
          );
          return;
        }

        options = _.extend(
          {
            template: svs.statistics.newstt.templates.news_tt_list,
            header: 'Nyheter från TT',
            parentId: 'svs-workarea-articles-newstt',
            numOfArticles: 10,
            displayMode: 'standard'
          },
          options.params
        );

        this.const = _.extend(
          {
            NO_OF_EXPANDED_NEWS: 3
          },
          this.const
        );

        this.constructor.__super__.initialize.apply(this, [options]);
      },

      getTemplate: function() {
        if (
          (this.isEmpty(this.collection) && this.isRendered) ||
          (this.isEmpty(this.collection) && this.isIntegrated())
        ) {
          return svs.statistics.newstt.templates.news_tt_error;
        }
        return this.constructor.__super__.getTemplate.apply(this, []);
      },

      onAddChild: function(collectionView, childView) {
        if (
          this.children.length <= this.const.NO_OF_EXPANDED_NEWS &&
          !this.isIntegrated()
        ) {
          childView.setInitialState(true);
        }
      }
    }
  );
})(Backbone, _, svs);

 })(window);